<template>
  <div class="main">
    <RadioGroup class="subRadio" :options="subRadioData" @radioChange="subRadioChange" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <div class="infos">
      <div class="item" v-for="(n, i) in infos" :key="'info' + i">
        <div class="label">{{ n.label }}</div>
        <div class="value">{{ n.value }}</div>
      </div>
    </div>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <Dialog class="dialog" ref="dialog" :title="title">
      <template #default>
        <el-form ref="form" :model="mform" :label-width="'110px'">
          <FormItem v-for="(c, i) in [mformCtrl[0], mformCtrl[1]]" :key="'mformItem' + i" :viewMode="viewMode"
            :config="c" :options="c.options" :inputValue="mform[c.keyName]" @onChange="onModalChange" />

          <el-form-item label="金额" prop="money" class="item">
            <div class="content">
              <el-input type="number" v-model="mform.money" placeholder="请填写金额" :disabled="mformCtrl[2].disabled"
                @input="changeMoney"></el-input>
              <div class="unit">元</div>
            </div>
          </el-form-item>

          <el-form-item label="加油量" prop="fuelnum" class="item">
            <div class="content">
              <el-input type="number" v-model="mform.fuelnum" placeholder="请填写加油量" :disabled="mformCtrl[3].disabled"
                @input="changeFuelnum"></el-input>
              <div class="unit">升</div>
            </div>
          </el-form-item>

          <FormItem v-for="(c, i) in [mformCtrl[4]]" :key="'mform2Item' + i" :viewMode="viewMode" :config="c"
            :options="c.options" :inputValue="mform[c.keyName]" @onChange="onModalChange" />
        </el-form>

        <div class="btns">
          <el-button v-if="!mform.id" type="primary" @click="onSubmit">确 定</el-button>
          <el-button @click="hideDialog">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'fuelsale',
      subRadioData: [
        { label: "全部", value: 0 },
        { label: "本月", value: 1 },
        { label: "上月", value: -1 },
        { label: "今天", value: 2 },
        { label: "昨天", value: 3 },
        { label: "前天", value: 4 },
      ],
      formInline: { daytime: 0 },
      formCtrl: [
        {
          ...this.ctrls.month,
          label: '订单月份：',
        },
        {
          label: "订单编号：",
          keyName: "license",
          placeholder: "请填写订单编号",
          type: "text",
        },
        {
          ...this.ctrls.license,
        },
      ],
      infos: [
        { label: '金额合计：', value: '10568元' },
        { label: '油量合计：', value: '1645.35升' },
      ],
      cols: [
        { prop: "oid", label: "订单编号" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "money", label: "金额", align:'right', className:'pr30' },
        { prop: "fuelnum", label: "加油量/升", align:'right', className:'pr30' },
        { prop: "cost", label: "成本", align:'right', className:'pr30' },
        { prop: "costmoney", label: "成本金额", align:'right', className:'pr30' },
        { prop: "profit", label: "利润", align:'right', className:'pr30' },
        { prop: "addtime", label: "时间"},
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id }) => {
            // console.log(id)
            this.viewMode = true
            this.getItemData(id)
            this.$nextTick(this.showDialog)
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加燃油订单',
      viewMode: false,
      mform: {},
      mformCtrl: [
        {
          label: "时间",
          keyName: "addtime",
          err: "请选择时间",
          type: "date",
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "select",
          options: [],
        },
        {
          label: "金额",
          keyName: "money",
          err: "请填写金额",
          type: "number",
          unit: "元",
        },
        {
          label: "加油量",
          keyName: "fuelnum",
          err: "请填写加油量",
          type: "number",
          unit: "升",
        },
        {
          label: "加油票据",
          keyName: "photo",
          type: "file",
        },
      ],
      money: 0,
      baseParams: ['daytime'],
    };
  },
  methods: {
    subRadioChange(v) {
      // console.log(v);
      this.formInline.daytime = v
      this.getList();
    },
    tableDataHandler({ count, data, total, totalfuel }) {
      this.total = count
      if (data && data.length) {
        this.tableData = [...data]
      }
      this.infos[0].value = total + '元'
      this.infos[1].value = totalfuel + '升'
    },
    add() {
      delete this.mform.id
      const addtime = this.DATE
      this.mform = { addtime }
      this.viewMode = false
      this.$nextTick(this.showDialog)
    },
    delReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/deldingdan`;
      const params = {
        userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: '删除失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
    getOptions() {
      let url = `${this.baseUrl}/findcar`;
      const params = {}
      this.post(url, params, ({ msg, car, money }) => {
        if (msg === 'success' && car && car.length) {
          this.mformCtrl.map(v => {
            if (v.keyName == 'license') {
              v.options = car.map(c => {
                return {
                  label: c.license,
                  value: c.license,
                }
              })
            }
            if (money) this.money = Number(money)
          })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getItemData(id) {
      let url = `${this.baseUrl}/editpro`;
      const params = { id }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          const { id, addtime, license, money, fuelnum, photo } = data;
          this.mform = { id, addtime, license, money, fuelnum, photo }
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    changeMoney(v) {
      // console.log(v)
      this.mform.money = v
      this.$set(this.mform, 'fuelnum', v / this.money)
      this.$forceUpdate()
      // console.log({ ...this.mform });
    },
    changeFuelnum(v) {
      // console.log(v)
      this.mform.fuelnum = v
      this.$set(this.mform, 'money', v * this.money)
      this.$forceUpdate()
      // console.log({ ...this.mform });
    },
    onSubmit() {
      // console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      // onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        ...this.mform,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getList()
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.main {
  .subRadio {
    text-align: left;
    background: #fff;
    margin: 0;
    padding: 20px;
    border-bottom: 3px solid #F2F6FC;

    /deep/ .el-radio-group {
      .el-radio-button {
        margin-right: 10px;

        .el-radio-button__inner {
          border: none;
          border-radius: 20px;
          padding: 8px 12px;
        }
      }
    }
  }

  .infos {
    background: #fff;
    display: flex;
    padding: 0 25px 25px;

    .item {
      display: flex;
      width: 200px;
      font-size: 14px;

      .label {
        color: #C0C4CC;
      }
    }
  }

  /deep/ .el-dialog {
    width: 520px;

    .el-form {
      .el-form-item {
        .content {
          position: relative;

          .el-date-editor.el-input,
          .el-input {
            width: 306px;
          }

          .unit {
            position: absolute;
            right: 75px;
            top: 0;
            color: #C0C4CC;
          }
        }
      }
    }

    .btns {
      margin: 0 auto;
      text-align: center;
    }
  }
}
</style>
